/**
 * Remove slashes from the start and end of a string
 * @param {string} str
 * @return {string}
 */
function stripSlashes(str) {
	return str.replace(/^\/+|\/+$/g, '');
}

export default (target, path) => {
	const current = stripSlashes(path);

	[...target.querySelectorAll('a.is-active, a.is-current')].forEach(link => {
		link.classList.remove('is-current');
	});
	[...target.querySelectorAll('a')].forEach(link => {
		const linkPath = stripSlashes(link.pathname);

		// Home link is current only on the homepage; every other link matches
		// the current page exactly or any sub-page within its section. The
		// trailing `/` boundary stops `/work` matching `/work-detail`.
		const isCurrent =
			linkPath === ''
				? current === ''
				: current === linkPath || current.startsWith(`${linkPath}/`);

		if (isCurrent) {
			link.classList.add('is-current');
		}
	});
};
